import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { SpracheLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';

interface SpracheProps {
    disabled: boolean;
    value: string;
    menuPlacement?: MenuPlacement;
    onChange: (newValue: string) => void;
}

export const Sprache: React.FC<SpracheProps> = ({ value, disabled, onChange, menuPlacement = 'bottom' }) => {
    return (
        <>
            <Label>Sprache</Label>
            <Select
                name="sprache"
                isDisabled={disabled}
                menuPlacement={menuPlacement}
                value={
                    value
                        ? {
                              value,
                              label: SpracheLabel[value] || value,
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={Object.keys(SpracheLabel).map((key) => ({
                    value: key,
                    label: SpracheLabel[key],
                }))}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || 'D');
                }}
            />
        </>
    );
};
